export const EXEC_NODE_URL = "http://0.0.0.0:4040/testnet3"
export const TESTNET_NODE_URL = "https://vm.aleo.org/api/testnet3"
export const PROGRAM_ID = "zkcheck_kyc.aleo"
export const PROGRAM_FUN = "main"
export const DEFAULT_EXEC_FEE = 10000
export const DEFAULT_PASSWORD = "12345"